// mission-lock-file-io.ts
//
// Tách THUẦN từ mission-lock.ts (phase 10, lô A): type `MachineLockFile` + đọc
// file lock thô (leaf — không phụ thuộc liveness/classify, tránh vòng import).

import { promises as fs } from "node:fs";

export interface MachineLockFile {
  missionId: string;
  ownerNonce: string;
  pid: number;
  processStartedAt?: string;
  childPids?: number[];
  acquiredAt: string;
  heartbeatAt: string;
}

export async function readMachineLock(lockPath: string): Promise<MachineLockFile | undefined> {
  try {
    return JSON.parse(await fs.readFile(lockPath, "utf8")) as MachineLockFile;
  } catch {
    return undefined;
  }
}
